var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD50ImageParallaxBlack = function SvgD50ImageParallaxBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d-50-image-parallax-black_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.592157 0 0 0 0 0.580392 0 0 0 0 0.623529 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-300 -695)",
    filter: "url(#d-50-image-parallax-black_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(310 705)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 26,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 30)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 1,
    r: 1
  }))))));
};
export default SvgD50ImageParallaxBlack;